// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./clients/web/src/stylesheets/body/collectionPage.styl
// module id = 242
// module chunks = 0